import React from 'react';

interface ApplicationSyncContextProps {
  isSynced: boolean;
  setIsSynced: (synced: boolean) => void;
}

export const ApplicationSyncContext = React.createContext<ApplicationSyncContextProps | null>(null);

export function useApplicationSyncContext() {
  const context = React.useContext(ApplicationSyncContext);
  if (!context) {
    throw new Error('useApplicationSyncContext must be used within a ApplicationSyncContextProvider');
  }
  return context;
}
